var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-8"},[_c('vs-card',[_c('pre',{staticClass:"json"},[_vm._v(_vm._s(_vm.blackList))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }